/**
 * An object for creating common table components in the Compuware web products.
 * 
 * @param tableName - A name for the table component; i.e. hostConnections
 * @param containerId - The Id of the container in which the table will be reside.
 * @param headers - An array of table column headers.
 * 
 * @returns A common table component
 * 
 * Note: The following variables should be defined before creating a SimpleTableComponent
 * to allow for proper text translations. If they are not defined then only an English
 * version will be displayed:
 * 
 * showLabelText
 * count10Text
 * count25Text
 * count50Text
 * count100Text
 * count500Text
 * countAllText
 * entriesLabelText
 * firstLabelText
 * previousLabelText
 * nextLabelText
 * lastLabelText
 * refreshText
 * exportTooltipText
 * copyToClipboardText
 * exportToCsvText
 * exportToExcelText
 * exportToPdfText
 * sendToPrinterText
 * filterPlaceholderText
 * filterText
 * addButtonText
 * editButtonText
 * deleteButtonText
 */
function SimpleTableComponent(tableName, containerId, headers, options) {
    var _TABLESUFFIX = 'Table';
    var _table = null;
    var _lastSelectedRow = 0;
    
    // make sure the tableName is a string and isn't an empty string
    if (typeof tableName !== 'string') {
        throw new Error('The table name must be a string');
    } else if (tableName.trim().length === 0) {
        throw new Error('The table name must not be an empty string');
    }

    // make sure the containerId is a string and isn't an empty string
    if (typeof containerId !== 'string') {
        throw new Error('The container ID name must be a string');
    } else if (containerId.trim().length === 0) {
        throw new Error('The container ID must not be an empty string');
    }

    // make sure the headers are an array and not an empty array
    if (!Array.isArray(headers)) {
        throw new Error('The headers must be an array');
    } else if (headers.length === 0) {
        throw new Error('The headers must not be an empty array');
    }

    var _tableName = tableName.trim();
    var _containerId = containerId.trim();
    var _headers = headers;
    var _toolbarContainerId = null;
    var _deleteConfirmationCallback = null;
    var _deleteCancelCallback = null;
    var _defaultOptions = {
        includeFilter : true,
        includeExport : false,
        includeExportTitle: '*',
        includeRefresh : false,
        filterCallback : _filterTable,
        includePagination : true,
        includeColumnFilter : false,
        toolbarContainerId: null,
        zAdviserCallback: null
    };

    if (!!options) {
        if (typeof options.includeFilter === 'boolean') {
            _defaultOptions.includeFilter = options.includeFilter;

            if (typeof options.filterCallback === 'function') {
                _defaultOptions.filterCallback = options.filterCallback;
            }
        }
        
        if (typeof options.includeColumnFilter === 'boolean')
        {
        	_defaultOptions.includeColumnFilter = options.includeColumnFilter;
        }

        if (typeof options.includeExport === 'boolean') {
            _defaultOptions.includeExport = options.includeExport;
        }

	    if (typeof options.includeExportTitle !== '*') {
	        _defaultOptions.includeExportTitle = options.includeExportTitle;
	    }

        if (typeof options.includeRefresh === 'boolean') {
            _defaultOptions.includeRefresh = options.includeRefresh;
        }

        if (typeof options.includePagination === 'boolean') {
            _defaultOptions.includePagination = options.includePagination;
        }
        
        if (!!options.toolbarContainerId) {
            _toolbarContainerId = options.toolbarContainerId;
            
            // if the # was included as part of the toolbarContainerId then remove the #
            if (_toolbarContainerId.indexOf('#') === 0) {
                _toolbarContainerId = _toolbarContainerId.substr(1);
            }
        }
    
	    if (!!options.zAdviserCallback && typeof options.zAdviserCallback === 'function') {
	        _defaultOptions.zAdviserCallback = options.zAdviserCallback;
	    }
    }

    // if the # was included as part of the containerId then remove the #
    if (_containerId.indexOf('#') === 0) {
        _containerId = _containerId.substr(1);
    }
    
    /**
     * Toggle the display of the table section.
     */
    var _toggleTableDisplay = function() {
        $(this).toggleClass('fa-rotate-90');
        $('#' + _containerId).slideToggle(250);
    };
    
    var _showDeleteConfirmationDialog = function(deleteCallback, cancelCallback, animateOpen, animateClose) {
        var confirmationDialog = document.getElementById('confirmationDialog');
        
        if (!confirmationDialog) {
            confirmationDialog = document.createElement('div');
            confirmationDialog.setAttribute('id', 'confirmationDialog');
            document.querySelector('body').appendChild(confirmationDialog);
        }
        
        $('#confirmationDialog').dialog({
            title : (typeof deleteDialogTitle !== 'undefined' ? deleteDialogTitle : 'Delete'),
            width : 400,
            modal : true,
            draggable : true,
            resizable : false,
            classes: {'ui-dialog' : 'cpwr-ui-dialog'},
            buttons : {
                "DELETE" : {
                    text : (typeof deleteButtonText !== 'undefined' ? deleteButtonText : 'Delete'),
                    'id' : 'confirmDeleteButton',
                    'class' : 'confirm-delete-button',
                    click : function() {
                        $.animateCloseDialog('#confirmationDialog', '#' + _tableName + 'DeleteButton');
                        $(this).dialog('close');
                        
                        if (typeof deleteCallback === 'function') {
                            deleteCallback.call(this);
                        } else if (typeof _deleteConfirmationCallback === 'function') {
                            _deleteConfirmationCallback.call(this);
                        }
                    }
                },
                "CANCEL" : {
                    text : (typeof cancelButtonText !== 'undefined' ? cancelButtonText : 'Cancel'),
                    click : function() {
                        if (typeof animateClose === 'undefined' || animateOpen) {
                            $.animateCloseDialog('#confirmationDialog', '#' + _tableName + 'DeleteButton');
                        }
                        
                        $(this).dialog('close');

                        if (typeof cancelCallback === 'function') {
                            cancelCallback.call(this);
                        } else if (typeof _deleteCancelCallback === 'function') {
                            _deleteCancelCallback.call(this);
                        }
                    }
                }
            },
            open: function() {
                var selectedRowCount = document.querySelectorAll(`#${_containerId} .row_selected`).length;
                var dialogBody = (typeof deleteDialogBody !== 'undefined' ? deleteDialogBody : `The ${selectedRowCount} selected item${selectedRowCount > 1 ? 's' : ''} will be permanently deleted.`);
                
                $(this).html(dialogBody);
                
                if (typeof animateOpen === 'undefined' || animateOpen) {
                    $.animateOpenDialog('#confirmationDialog', '#' + _tableName + 'DeleteButton', true, null, function() {
                        document.getElementById('confirmDeleteButton').focus();
                    });
                }
            },
            close: function(event, ui) {
                $(this).html('');
            }
        });        
    };
    
    var _enableTableButtons = function() {
        var buttons = document.querySelectorAll(`#${_containerId} > .table-controls > button[data-enablement]`);
        
        for (var index = 0; index < buttons.length; index++) {
            var button = buttons[index];
            
            if (!!button) {
            	if ($(`#${_containerId} td`).hasClass('dataTables_empty')) {
                    button.setAttribute('disabled', 'disabled');
            	}
            	else {
            		var selectedRowCount = document.querySelectorAll('.row_selected').length;
                    var enablement = button.getAttribute('data-enablement');
                    
                    if (enablement === 'single') {
                        if (selectedRowCount === 1) {
                            button.removeAttribute('disabled');
                        } else {
                            button.setAttribute('disabled', 'disabled');
                        }
                    } else if (enablement === 'multi') {
                        if (selectedRowCount > 0 ) {
                            button.removeAttribute('disabled');
                        } else {
                            button.setAttribute('disabled', 'disabled');
                        }
                    }
            	} 
            }
        }
    };
    
    var _singleRowSelectionHandler = function(event) {
        var tableRow = event.currentTarget;
        var tableObject = $(tableRow).parents('table').dataTable();
        
        if (tableRow && tableObject) {
            if (event.button !== 2) {
                if ($(tableRow).hasClass('row_selected')) {
                    if (event.ctrlKey) {
                        $(tableRow).removeClass('row_selected');
                    }
                } else {
                    if (!$(tableRow).hasClass('row_selected')) {
                        tableObject.$('tr.row_selected').removeClass('row_selected');
                        $(tableRow).addClass('row_selected');
                    }
                }
            } else {
                if (!$(tableRow).hasClass('row_selected')) {
                    tableObject.$('tr.row_selected').removeClass('row_selected');
                    $(tableRow).toggleClass('row_selected');
                }
            }
            
            _enableTableButtons();
        }
    };
    
    var _multiRowSelectionHandler = function(event) {
        var tableRow = event.currentTarget;
        var tableObject = $(tableRow).parents('table').dataTable();
        
        if (tableRow && tableObject) {
            if (event.button !== 2) {
                if (!event.ctrlKey && !event.shiftKey) {
                    tableObject.$('tr.row_selected').removeClass('row_selected');
                    $(tableRow).toggleClass('row_selected');
                    _lastSelectedRow = $(this)[0].rowIndex;
                } else if (event.ctrlKey && !event.shiftKey) {
                    $(tableRow).toggleClass('row_selected');
                    
                    if (tableObject.$('tr.row_selected').length > 0) {
                        _lastSelectedRow = $(tableRow)[0].rowIndex;
                    } else {
                        _lastSelectedRow = 0;
                    }
                } else if (!event.ctrlKey && event.shiftKey) {
                    if (_lastSelectedRow === 0) {
                        $(tableRow).toggleClass('row_selected');
                        _lastSelectedRow = $(tableRow)[0].rowIndex;
                    } else {
                        tableObject.$('tr.row_selected').removeClass('row_selected');
                        var rows = $(tableObject).find('> tbody > tr');
                        var selectedRow = $(tableRow)[0].rowIndex;
                        var firstRow = Math.min(selectedRow, _lastSelectedRow);
                        var lastRow = Math.max(selectedRow, _lastSelectedRow);
                        
                        for (var index = firstRow; index <= lastRow; index++) {
                            $(rows[index - 1]).toggleClass('row_selected');
                        }
                    }
                }
            } else {
                if (!$(tableRow).hasClass('row_selected')) {
                    tableObject.$('tr.row_selected').removeClass('row_selected');
                    $(tableRow).toggleClass('row_selected');
                    _lastSelectedRow = $(this)[0].rowIndex;
                }
            }
            
            _enableTableButtons();
        }
    };
    
    /**
     * Initialize the DataTables table.
     * 
     * @param dataTablesOptions - The options for DataTables. A columns property in the DataTables options is required.
     * @param rowSelectionType - Specify 'single' for single-row selection, 'multi' for multi-row selection, or null for no row selection.
     * 
     * @returns The DataTables table.
     */
    const _initializeDataTable = function(dataTablesOptions, rowSelectionType) {
        if (!_table) {
        	const tableId = `#${_tableName}${_TABLESUFFIX}`;
        	const rowCountId = `${tableId}RowCount`;
        	const paginationId = `${tableId}Pagination`;
            const tableExportWrapperId = `#export${_tableName[0].toUpperCase()}${_tableName.substring(1)}${_TABLESUFFIX}Wrapper`;
            const tableFilterIconId = `#filter${_tableName[0].toUpperCase()}${_tableName.substring(1)}${_TABLESUFFIX}`;
            const tableFilterAddId = `#filter-add${_tableName[0].toUpperCase()}${_tableName.substring(1)}${_TABLESUFFIX}`;
            const tableFilterId = `${tableFilterIconId}Input`;
            const tableContainerEl = document.querySelector(`#${_containerId}`);
            const tabContainer = tableContainerEl.closest('.tab-contents');
            const tableIsContainedInTab = tabContainer !== null;
            //To scroll the user to different parts of the table, we need to find the parent of this table that is scrollable
            //When in tabs, this is the closest element with .tab-contents -- when not in a tab, this is simply window itself
            const scrollableParentSelector = tableIsContainedInTab ? `#${tabContainer.id}` : 'html, body';
            let pageSize = sessionStorage.getItem(rowCountId);
            let currentPageSize = null;
           
            if (!pageSize) {
                // if page size wasn't in session storage then default it to what was passed in, or 25 if nothing was passed in
                pageSize = !!dataTablesOptions.pageLength ? dataTablesOptions.pageLength : 25;
            }
           
            if (!dataTablesOptions.data) {
                dataTablesOptions.data = [];
            } else if (!Array.isArray(dataTablesOptions.data)) {
                dataTablesOptions.data = [dataTablesOptions.data];
            }
            
            const _defaultDataTablesOptions = {
                processing : false,
                autoWidth : false,
                deferRender : true,
                order : [[0, 'asc']],
                dom : 't',
                paging : false,
                lengthChange : false,
                pagingType : 'full_numbers',
                pageLength : -1, 
                buttons : [],
                language : {},
                stateSave : true,
                stateSaveCallback : function(settings, data) {
                    localStorage.setItem(tableId.substring(1) + '_' + settings.sInstance, JSON.stringify(data));
                },
                stateLoadCallback : function(settings) {
                    return _loadTableState(settings, tableId.substring(1) + '_', tableFilterId);
                },
                initComplete : null,
                rowCallback : null
            };

            for (var propertyName in dataTablesOptions) {
                _defaultDataTablesOptions[propertyName] = dataTablesOptions[propertyName];
            }

            if (_defaultOptions.includePagination) {
                _defaultDataTablesOptions.dom = 'Rt<"' + rowCountId + '"l><"' + paginationId + '"p>';
                _defaultDataTablesOptions.lengthChange = true;
                _defaultDataTablesOptions.paging = true;
                _defaultDataTablesOptions.pageLength = pageSize;
                _defaultDataTablesOptions.language.paginate = {
                        first : '<i class="fa fa-step-backward" aria-label="' + (typeof firstLabelText !== 'undefined' ? firstLabelText : 'First') + '"></i>',
                        previous : '<i class="fa fa-caret-left" aria-label="' + (typeof previousLabelText !== 'undefined' ? previousLabelText : 'Previous') + '"></i>',
                        next : '<i class="fa fa-caret-right" aria-label="' + (typeof nextLabelText !== 'undefined' ? nextLabelText : 'Next') + '"></i>',
                        last : '<i class="fa fa-step-forward" aria-label="' + (typeof lastLabelText !== 'undefined' ? lastLabelText : 'Last') + '"></i>'
                }; 
                
                //If lengthMenu has been set, we don't want to modify its content with language.lengthMenu
                if(typeof _defaultDataTablesOptions.lengthMenu === 'undefined') {
                	_defaultDataTablesOptions.language.lengthMenu = (typeof showLabelText !== 'undefined'  ? showLabelText : 'Show') + '<select>' +
	                '<option value="10">' + (typeof count10Text !== 'undefined' ? count10Text : '10') + '</option>' +
	                '<option value="25">' + (typeof count25Text !== 'undefined'  ? count25Text : '25') + '</option>' +
	                '<option value="50">' + (typeof count50Text !== 'undefined'  ? count50Text : '50') + '</option>' +
	                '<option value="100">' + (typeof count100Text !== 'undefined'  ? count100Text : '100') + '</option>' +
	                '<option value="500">' + (typeof count500Text !== 'undefined'  ? count500Text : '500') + '</option>' +
	                '<option value="-1">' + (typeof countAllText !== 'undefined'  ? countAllText : 'All') + '</option>' +
	                '</select>' + (typeof entriesLabelText !== 'undefined'  ? entriesLabelText : 'entries');
                }
                
                _defaultDataTablesOptions.initComplete = function(settings, json) {
                    const paginationContainerClass = '.' + _tableName + '-table.pagination-controls';
                    const rowCountWidget = $(rowCountId);
                    rowCountWidget.addClass('row-count');
                    rowCountWidget.appendTo(paginationContainerClass);
                    
                    const paginationWidget = $(paginationId);
                    paginationWidget.addClass('pagination');
                    paginationWidget.appendTo(paginationContainerClass);
                    currentPageSize = tableContainerEl.querySelector('select').value;
                };
            }

            if (!!_defaultOptions.includeExport) {
                _defaultDataTablesOptions.dom = _defaultDataTablesOptions.dom + 'B';
                _defaultDataTablesOptions.buttons = [{
                    extend : 'print', 
		            title: _defaultOptions.includeExportTitle,
                    exportOptions: {columns: ':visible'}
                }, {
                    extend : 'copyHtml5', 
                    exportOptions: {columns: ':visible'}
                }, {
                    extend : 'csvHtml5', 
                    exportOptions: {columns: ':visible'}
                }, {
                    extend : 'excelHtml5', 
		            title: _defaultOptions.includeExportTitle,
                    exportOptions: {columns: ':visible'}
                }, {
                    extend : 'pdfHtml5', 
		            title: _defaultOptions.includeExportTitle,
		            exportOptions: {columns: ':visible'}
                }];
                
                $(tableExportWrapperId + ' > .export-wrapper-toggle').click(_handleExportClicked);
                $(tableExportWrapperId + ' > .export-options-wrapper > .export-option').on('click', _handleExportOptionClicked);
            }

            _table = $(tableId).DataTable(_defaultDataTablesOptions);
            
            if (!!_defaultOptions.includeColumnFilter) {
            	
            	const columnSelection = document.getElementById(_tableName + '-filter-selection');
            	
        		_table.columns().every(function () {
        		    const that = this;
        		    const header = that.header().title;
        		    	    
        		    if (header != '') { // don't include hidden columns  	
	            		const option = document.createElement('option');
	            		option.text = header;
	            		option.value = header;
	            		columnSelection.appendChild(option);
        		    }
        		});
        		
        		$(tableFilterAddId).click(_handleFilterAddClicked);
        		$('#' + _tableName + '-filter-selection').change(_handleFilterSelectionChanged);
                const filterValue = $(tableFilterId).val();
                
        		_filterTable(_table, filterValue);
            }   	       
            
            if (!!_defaultOptions.includeFilter) {
                $(tableFilterIconId).click(_handleFilterClicked);
                
                $(tableFilterId).keyup(function(event) {
                	if (!!_defaultOptions.includeColumnFilter) {
                		
                		const keycode = event.keyCode || event.which;
                		if (keycode == '13') {
                			if (_validateValidFilter($(this).val()))
                				_handleFilterAddClicked();   
                	    } else {
                    		_handleAddFilterIconDisplay($(this).val());
                	    }
                	}

                	_defaultOptions.filterCallback(_table, $(this).val());
                });
            }
            
            if (!!rowSelectionType) {
                if (rowSelectionType.toLowerCase() === 'multi') {
                    $(tableId).on('click', 'tbody > tr', _multiRowSelectionHandler);
                } else if (rowSelectionType.toLowerCase() === 'single') {
                    $(tableId).on('click', 'tbody > tr', _singleRowSelectionHandler);
                }
                
                _table.on('draw', _enableTableButtons)
            }
            
	        //When the table is not contained in a tab, the window will not resize itself when the pagination length is reduced
	        //To prevent the user from needing to scroll up to see the page at this smaller size, we need to scroll them automatically
	        if(!tableIsContainedInTab) {
	        	$(tableId).on('length.dt', function(event, settings, newPageSize) {
	            	if(newPageSize < currentPageSize || currentPageSize === -1) {
	                	//The length.dt event fires *before* the table is re-drawn on the draw.dt event, so we store the previous table height here
	                	const currentTableHeight = tableContainerEl.offsetHeight;
	                	
	                	$(this).one('draw.dt', function () {
	                		const newTableHeight = tableContainerEl.offsetHeight;
	                		const tableHeightDifference = newTableHeight - currentTableHeight;
	                		
	                		window.scrollTo({top : window.pageYOffset + tableHeightDifference, behavior : 'smooth'});
	                	});
	            	}
	            	currentPageSize = newPageSize;
	    		});
	        }
	        
	        $(tableId).on('page.dt', function () {		       	
		       	$(scrollableParentSelector).animate(
		        		{scrollTop: 0},
		       		    200,
		       		    'swing'
		       	);
	        });
	        
        }

        return _table;
    };
    
    /**
     * Create the table header rows.
     * 
     * @param headers - An array of header column definitions. Each header column is required to have a title property which is used 
     * for displaying the text of the header column. A class attribute can be associated with the header column by specifying
     * a clazz or classname property. Any other property specified on the header column will be added as an attribute of the
     * header column.
     * 
     * @returns An array of table header rows.
     */
    var _createTableHeaderRows = function(headers) {
        var tableHeaderRows = [];
        var tableHeaderRow = document.createElement('tr');

        for (var index = 0; index < headers.length; index++) {
            var header = headers[index];
            
            if (Array.isArray(header)) {
                tableHeaderRows = tableHeaderRows.concat(_createTableHeaderRows(header));
            } else if (!header.title) {
                throw new Error('Each header must contain a title property');
            } else {
                var tableHeaderColumn = document.createElement('th');

                for (var property in header) {
                    var caseInsensitiveProperty = property.toLowerCase();
                    
                    if (header.hasOwnProperty(property)) {
                        var headerProperty = header[property];

                        // make sure the id for this header column doesn't exist in the DOM already
                        if (caseInsensitiveProperty === 'id' && !!document.getElementById(headerProperty)) {
                            throw new Error('A DOM element with an ID of ' + headerProperty + ' already exists');
                        }

                        if (caseInsensitiveProperty === 'clazz' || caseInsensitiveProperty === 'classname') {
                            property = 'class';
                        }

                        if (caseInsensitiveProperty !== 'displayvalue') {
                            tableHeaderColumn.setAttribute(property, headerProperty);
                        }
                    }
                }

                // if a displayValue is present then use that as the text node, otherwise use the title as the text node
                var tableHeaderColumnText = document.createTextNode(!!header.displayValue ? header.displayValue : header.title);
                tableHeaderColumn.appendChild(tableHeaderColumnText);
                tableHeaderRow.appendChild(tableHeaderColumn);
            }
        }

        if (tableHeaderRow.hasChildNodes()) {
            tableHeaderRow.setAttribute('class', 'table-header-row');
            tableHeaderRows.push(tableHeaderRow);
        }
        
        return tableHeaderRows;
    };

    /**
     * Add the toolbar items. The toolbar items can be refresh (optionally) and filter.
     * 
     * @param toolbar - The toolbar to which the items will be added.
     * @param refreshCallback - The callback for the refresh toolbar item. This is optional.
     * @param refreshClass - The class to be assigned to the refresh toolbar item. This is optional.
     */
    var _addToolbarItems = function(toolbar, refreshCallback, refreshClass) {
        if (!!_defaultOptions.includeRefresh) {
            if (!!refreshCallback) {
                var refreshIcon = document.createElement('button');
                refreshIcon.setAttribute('class', 'fa fa-refresh ' + refreshClass);
                refreshIcon.setAttribute('title', (typeof refreshText !== 'undefined' ? refreshText : 'Refresh'));
                refreshIcon.setAttribute('aria-label', (typeof refreshText !== 'undefined' ? refreshText : 'Refresh'));
                refreshIcon.id = 'refresh' + _tableName[0].toUpperCase() + _tableName.substring(1);
                toolbar.appendChild(refreshIcon);
            }
        }

        if (!!_defaultOptions.includeExport) {
            var exportWrapper = document.createElement('div');
            exportWrapper.setAttribute('class', 'export-wrapper');
            exportWrapper.id = 'export' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX + 'Wrapper';
            
            var exportOptionsWrapper = document.createElement('div');
            exportOptionsWrapper.setAttribute('class', 'export-options-wrapper');
            
            var exportCopyIcon = document.createElement('button');
            exportCopyIcon.setAttribute('class', 'export-option export-copy fa fa-clipboard table-toolbar-item');
            exportCopyIcon.setAttribute('title', (typeof copyToClipboardText !== 'undefined' ? copyToClipboardText : 'Copy to clipboard'));
            exportCopyIcon.setAttribute('aria-label', (typeof copyToClipboardText !== 'undefined' ? copyToClipboardText : 'Copy to clipboard'));
            exportOptionsWrapper.appendChild(exportCopyIcon);
            
            var exportCsvIcon = document.createElement('button');
            exportCsvIcon.setAttribute('class', 'export-option export-csv fa fa-file-text-o table-toolbar-item');
            exportCsvIcon.setAttribute('title', (typeof exportToCsvText !== 'undefined' ? exportToCsvText : 'Export to CSV'));
            exportCsvIcon.setAttribute('aria-label', (typeof exportToCsvText !== 'undefined' ? exportToCsvText : 'Export to CSV'));
            exportOptionsWrapper.appendChild(exportCsvIcon);

            var exportExcelIcon = document.createElement('button');
            exportExcelIcon.setAttribute('class', 'export-option export-excel fa fa-file-excel-o table-toolbar-item');
            exportExcelIcon.setAttribute('title', (typeof exportToExcelText !== 'undefined' ? exportToExcelText : 'Export to Excel'));
            exportExcelIcon.setAttribute('aria-label', (typeof exportToExcelText !== 'undefined' ? exportToExcelText : 'Export to Excel'));
            exportOptionsWrapper.appendChild(exportExcelIcon);

            var exportPdfIcon = document.createElement('button');
            exportPdfIcon.setAttribute('class', 'export-option export-pdf fa fa-file-pdf-o table-toolbar-item');
            exportPdfIcon.setAttribute('title', (typeof exportToPdfText !== 'undefined' ? exportToPdfText : 'Export to PDF'));
            exportPdfIcon.setAttribute('aria-label', (typeof exportToPdfText !== 'undefined' ? exportToPdfText : 'Export to PDF'));
            exportOptionsWrapper.appendChild(exportPdfIcon);

            var exportPrintIcon = document.createElement('button');
            exportPrintIcon.setAttribute('class', 'export-option export-print fa fa-print table-toolbar-item');
            exportPrintIcon.setAttribute('title', (typeof sendToPrinterText !== 'undefined' ? sendToPrinterText : 'Send to printer'));
            exportPrintIcon.setAttribute('aria-label', (typeof sendToPrinterText !== 'undefined' ? sendToPrinterText : 'Send to printer'));
            exportOptionsWrapper.appendChild(exportPrintIcon);
                
            var exportWrapperToggle = document.createElement('div');
            exportWrapperToggle.setAttribute('class', 'export-wrapper-toggle');

            var exportExternalIcon = document.createElement('button');
            exportExternalIcon.setAttribute('class', 'fa fa-external-link table-toolbar-item');
            exportExternalIcon.setAttribute('title', (typeof exportTooltipText !== 'undefined' ? exportTooltipText : 'Export'));
            exportExternalIcon.setAttribute('aria-label', (typeof exportTooltipText !== 'undefined' ? exportTooltipText : 'Export'));
            exportWrapperToggle.appendChild(exportExternalIcon);
            
            exportWrapper.appendChild(exportOptionsWrapper);
            exportWrapper.appendChild(exportWrapperToggle);
            toolbar.appendChild(exportWrapper);
        }
        
        if (!!_defaultOptions.includeFilter) {
            var filterWrapper = document.createElement('div');
            filterWrapper.setAttribute('class', 'filter-wrapper');
            
            if (!!_defaultOptions.includeColumnFilter) {
            	var columnSelection = document.createElement('select');
            	columnSelection.id = _tableName + '-filter-selection';
            	columnSelection.classList.add('filter-selection');
            	var allOption = document.createElement('option');
            	allOption.text = 'All';
            	allOption.value = 'all';
            	columnSelection.appendChild(allOption);
            	
            	columnSelection.style.display = 'none';
            	filterWrapper.appendChild(columnSelection);
            }
            
            var filterInput = document.createElement('input');
            filterInput.setAttribute('type', 'text');
            filterInput.setAttribute('placeholder', (typeof filterPlaceholderText !== 'undefined' ? filterPlaceholderText : 'Enter filter text here'));
            filterInput.setAttribute('class', 'filter-input');
            filterInput.id = 'filter' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX + 'Input';
            filterWrapper.appendChild(filterInput);
            
            if (!!_defaultOptions.includeColumnFilter) {
	            var filterAddIcon = document.createElement('button');
	            filterAddIcon.setAttribute('class', 'fa fa-plus table-toolbar-item');
	            filterAddIcon.setAttribute('title', (typeof filterText !== 'undefined' ? filterText : 'Add Filter'));
	            filterAddIcon.setAttribute('aria-label', (typeof filterText !== 'undefined' ? filterText : 'Add Filter'));
	            filterAddIcon.id = 'filter-add' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX;
	            filterAddIcon.style.display = 'none';
	            filterWrapper.appendChild(filterAddIcon);
            }
            
            var filterIcon = document.createElement('button');
            filterIcon.setAttribute('class', 'fa fa-filter table-toolbar-item');
            filterIcon.setAttribute('title', (typeof filterText !== 'undefined' ? filterText : 'Filter'));
            filterIcon.setAttribute('aria-label', (typeof filterText !== 'undefined' ? filterText : 'Filter'));
            filterIcon.id = 'filter' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX;
            filterWrapper.appendChild(filterIcon);
            toolbar.appendChild(filterWrapper);
        }
    };
    
    /**
     * Creates a table control button. The button can be one of Add, Edit, or Delete.
     * 
     * @param buttonData - The data representing the button to be added to the table controls.
     * @param suffix - The suffix to be added to the button Id.
     * @param buttonText - The text to display on the button.
     * 
     * @returns The button component to be added to the table controls.
     */
    var _createTableControlButton = function(buttonData, suffix, buttonText) {
        var button = document.createElement('button');
        button.id = _tableName + suffix;

        for (var property in buttonData) {
            if (buttonData.hasOwnProperty(property)) {
                var buttonProperty = buttonData[property];

                if (property === 'callback') {
                    button.addEventListener('click', buttonProperty);
                    continue;
                }

                if (property === 'enablement') {
                    button.setAttribute('data-enablement', buttonProperty);
                    continue;
                }
                
                if (property === 'clazz' || property === 'classname') {
                    property = 'class';
                }
                
                // ignore id, title, and tabindex properties since we'll assign our own id and title to the button
                if (property !== 'id' && property !== 'title' && property !== 'tabindex' && property !== 'deleteConfirmationCallback' && property !== 'deleteCancelCallback') {
                    button.setAttribute(property, buttonProperty);
                    continue;
                }
            }
        }
        
        var buttonTextNode = document.createTextNode(buttonText);
        button.appendChild(buttonTextNode);
        button.setAttribute('title', buttonText);
        button.setAttribute('aria-label', buttonText);
        button.setAttribute('tabindex', '0');
        return button;
    };

    var _handleExportOptionClicked = function(event) {
        var $currentTarget = $(event.currentTarget);
        var $currentExportWrapper = $currentTarget.closest('.export-wrapper');
        var tableId = '#' + _tableName + _TABLESUFFIX;
        var exportButton;
        var exportMessage;
        
        if ($currentTarget.hasClass('export-copy')) {
            exportButton = '.buttons-copy';
            exportMessage = (typeof copyExportDone !== 'undefined') ? copyExportDone : 'The table has been copied to the clipboard.';
        } else if ($currentTarget.hasClass('export-csv')) {
            exportButton = '.buttons-csv';
        } else if ($currentTarget.hasClass('export-excel')) {
            exportButton = '.buttons-excel';
        } else if ($currentTarget.hasClass('export-pdf')) {
            exportButton = '.buttons-pdf';
        } else if ($currentTarget.hasClass('export-print')) {
            exportButton = '.buttons-print';
        }
        
        // click on the hidden datatable export controls
        if (!!exportButton) {
            $(tableId).parent().find(exportButton).click();
            
            if (!!exportMessage) {
                $.showSuccessStatus(exportMessage)
            }
	
	        if(exportButton === '.buttons-pdf' &&  _defaultOptions.zAdviserCallback !== null){
	        	 _defaultOptions.zAdviserCallback();
	        }
        }
        
        // close export wrapper if open
        if ($currentExportWrapper.hasClass('open')) {
            $currentExportWrapper.find('.export-wrapper-toggle > i').click();
        }        
    };
    
    var _handleExportClicked = function(event) {
        var $target = $(event.target);
        $target.toggleClass('fa-external-link');
        $target.toggleClass('fa-times');
        $target.closest('.export-wrapper').toggleClass('open');
    };
    
    var _handleFilterClicked = function(event) {
        var $filterWrapper = $(this).parent();
        var $filterInput = $filterWrapper.find("input");
        var $filterSelection = $filterWrapper.find("select");
        var $filterAddIcon = $('#filter-add' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX);

        if ($filterWrapper.hasClass("open")) {     	
        	if (_defaultOptions.includeColumnFilter) {
        		$filterSelection[0].style.display = "none";
        		$filterAddIcon[0].style.display = "none";
        	}
        	
            $filterWrapper.removeClass("open");
            $(this).removeClass("fa-times");
            $(this).addClass("fa-filter");
            $filterInput.val("");
            $filterInput.keyup();
            
            if (_defaultOptions.includeColumnFilter)
            	_filterTable(_table, $filterInput.val());
        } else {
        	if (_defaultOptions.includeColumnFilter) {
        		$filterSelection[0].style.display = "inline";
        		$filterAddIcon[0].style.display = "inline-block";
        		
        		if ($filterSelection[0].value == "all") {
        			$filterAddIcon[0].classList.add("disabled");		
        		}
        	}
        	
            $filterWrapper.addClass("open");
            $filterInput.focus();
            $(this).removeClass("fa-filter");
            $(this).addClass("fa-times");
        }

        event.stopPropagation();
    };
    
    var _handleFilterAddClicked = function(event) {        
        var tableId = '#' + _tableName + _TABLESUFFIX;
        var storageKey = tableId.substring(1) + '_filters';
        
        var tableFilterIconId = '#filter' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX;
        var tableFilterId = tableFilterIconId + 'Input';
        
        var column = document.getElementById(_tableName + '-filter-selection').value;
        var filterText = $(tableFilterId).val();
        
        var existingFilters = JSON.parse(localStorage.getItem(storageKey));
        
        if (!!existingFilters) { // if filters exist at all
        	var filters = existingFilters[column];
        	
        	if (!!filters) { // if duplicate filter exists in a specific column       		
        		var foundIndex = filters.indexOf(filterText);	
	        	if (foundIndex == -1) {
	        		filters.push(filterText);
	        		existingFilters[column] = filters;
	        	}
        	} else {
        		existingFilters[column] = new Array(filterText);
        	}
        } else {
        	existingFilters = {};
        	existingFilters[column] = new Array(filterText);
        }
            
        var $filterInput = $(tableFilterId);
        $filterInput.val("");
        
    	localStorage.setItem(storageKey, JSON.stringify(existingFilters));
    	
    	_handleAddFilterIconDisplay($filterInput.val());
    	_filterTable(_table, $filterInput.val());
    	$('body').trigger('filterPillModified');
    };
    
    var _handleFilterSelectionChanged = function(event) {
        var tableFilterId = 'filter' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX + 'Input';
        var filterValue = document.getElementById(tableFilterId).value;

        _handleAddFilterIconDisplay(filterValue);
        _filterTable(_table, filterValue)
    };
    
    function _handleAddFilterIconDisplay(filterValue) {
        var addFilterIconId = 'filter-add' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX;
        var addFilterIcon = document.getElementById(addFilterIconId);
        
        if (_validateValidFilter(filterValue)) {
        	addFilterIcon.style.display = 'inline-block';
        	addFilterIcon.classList.remove("disabled");
        }
        else
        	addFilterIcon.classList.add("disabled");
    }
    
    function _validateValidFilter(filterValue) {
        var columnSelection = document.getElementById(_tableName + '-filter-selection');
        
        if (!!columnSelection && columnSelection.value != 'all' && !!filterValue) {
        	return true;
        }
        else
        	return false;
    }

    function _filterTable(table, filterValue) {
        if (!!table) {
            if (!!table.fnFilter) {
                table.fnFilter(filterValue);
            } else {
            	if (!!_defaultOptions.includeColumnFilter) {
            		var columnSelection = document.getElementById(_tableName + '-filter-selection');
            		
            		var tableId = '#' + _tableName + _TABLESUFFIX;
                    _loadFilters(columnSelection.value, filterValue);
                    
                    if (columnSelection.value == 'all')
                    	_table.search(filterValue).draw();
                    else
                    	_table.search('').draw();
            	} else {
            		table.search(filterValue).draw();
            	}
            }
        }
    }
    
    function _loadFilters(selectedColumn, filterText)
    {
    	var tableId = '#' + _tableName + _TABLESUFFIX;
    	var filters = JSON.parse(localStorage.getItem(tableId.substring(1) + '_filters'));
    	var filterContainerId = _tableName + _TABLESUFFIX + "-filters-container";
    	var filtersContainer = document.getElementById(filterContainerId);
    	
    	//clear all filters
    	while (filtersContainer.firstChild) {
    		filtersContainer.removeChild(filtersContainer.firstChild);
    	}
    	
    	_table.columns().every(function () {
		    var that = this;
		    var header = that.header().title;
		    var filterValues = ''; // '' = search everything
		    
		    if (header == selectedColumn) {
		    	filterValues = filterText;
		    }	    
		    
		    if (!!filters) {
			    if (!!filters[header]) {
			    	for (var i in filters[header]) {
			    		_createFilterPill(header, filters[header][i]);
			    	}
			 	
			    	var savedFilterValues = filters[header].join('|');
			    	
			    	if (!!filterValues && !!savedFilterValues)
			    		filterValues = filterValues + '|' + savedFilterValues;
		    		else if (!!savedFilterValues)
		    			filterValues = savedFilterValues;
			    }    
		    }
		    
	    	_table.columns(that.index()).search(filterValues, true, false).draw();
		});
    }
    
    function _createFilterPill(column, filterText) {
    	var filterContainerId = _tableName + _TABLESUFFIX + "-filters-container";
    	var filterContainer = document.getElementById(filterContainerId);
    	var newFilterPill = document.createElement('div');
    	newFilterPill.classList.add('filter-pill-wrapper');
    	var newFilterText = document.createElement('span');
    	newFilterText.textContent = column + ' : ' + filterText;
    	
    	var closeFilterIcon = document.createElement('button');
    	closeFilterIcon.setAttribute('aria-label', 'Delete Filter ' + filterText + ' for column ' + column);
    	closeFilterIcon.classList.add('fa');
    	closeFilterIcon.classList.add('fa-times');
    	
    	closeFilterIcon.addEventListener('click', function() {
    		var tableId = '#' + _tableName + _TABLESUFFIX;
            var storageKey = tableId.substring(1) + '_filters';      
    		var existingFilters = JSON.parse(localStorage.getItem(storageKey));
    		
    		var filters = existingFilters[column];
    		if (!!filters) {						
				var index = filters.indexOf(filterText);
				if (index != -1) {
					filters.splice(index, 1);
					existingFilters[column] = filters;
				}
    		}
    		
    		localStorage.setItem(storageKey, JSON.stringify(existingFilters));
    		
    		_handleAddFilterIconDisplay('');
    		
    		var tableFilterId = 'filter' + _tableName[0].toUpperCase() + _tableName.substring(1) + _TABLESUFFIX + 'Input';
            var filterValue = document.getElementById(tableFilterId).value;
    		_filterTable(_table, filterValue);
    		$('body').trigger('filterPillModified');
		});
    	
    	newFilterPill.appendChild(newFilterText);
    	newFilterPill.appendChild(closeFilterIcon);
    	filterContainer.appendChild(newFilterPill);
    }

    _loadTableState = function(settings, prefix, filterID) {
        var tableState = JSON.parse(localStorage.getItem(prefix + settings.sInstance));
        
        if (!!tableState && !!tableState.search && !!tableState.search.search) {
            if (!!filterID) {
                var $filterInput = $(filterID);
                var $filterWrapper = $filterInput.closest('.filter-wrapper');
                var $filterIcon = $filterWrapper.find('i');
                
                $filterWrapper.addClass('open');
                $filterInput.val(tableState.search.search);
                $filterIcon.removeClass('fa-filter');
                $filterIcon.addClass('fa-times');
            } else {
                tableState.search.search = '';
            }
        }
        
        return tableState;
    };    

    /**
     * Create the DataTables table and populate the DOM with the necessary elements.
     * 
     * @param dataTablesOptions - The options for DataTables. A columns property in the DataTables options is required. Note: the list of options
     * used can be found in the _initializeDataTable function.
     * @param rowSelectionType - Specify 'single' for single-row selection, 'multi' for multi-row selection, or null for no row selection.
     * @param tableSectionTitle - The title of the collapsible section. If this is null or undefined then a collapsible section will not be added
     * @param refreshCallback - The callback for the refresh button. If this is null or undefined then a refresh button will not be added. The
     * callback is responsible for clearing the table, getting the table data, and updating the table with that data.
     * @param tableControls - Specifies the control buttons to be added; i.e. Add/Edit/Delete. An object with an optional addButton, editButton, and 
     * deleteButton properties needs to be defined if the table needs these controls.
     * 
     * @returns A DataTable representation of the table component.
     */
    this.createTable = function(dataTablesOptions, rowSelectionType, tableSectionTitle, refreshCallback, tableControls) {
        if (!dataTablesOptions) {
            throw new Error('DataTables options are required');
        }
        
        if (!dataTablesOptions.columns) {
            throw new Error('Columns are required');
        }
        
        if (!Array.isArray(dataTablesOptions.columns)) {
            dataTablesOptions.columns = [dataTablesOptions.columns];
        }
        
        var existingTable = document.getElementById(_tableName + _TABLESUFFIX);

        if (!!existingTable) {
            throw new Error('A table with the name ' + _tableName + ' already exists');
        }
        
        var tableContainer = document.getElementById(_containerId);

        if (!tableContainer) {
            throw new Error('A DOM element with an ID of ' + _containerId + ' does not exist');
        }
        
        if (!!_defaultOptions.includeColumnFilter) {
        	var filtersContainer = document.createElement('div');
        	filtersContainer.id = _tableName + _TABLESUFFIX + "-filters-container";  
        	var tableContainerParent = tableContainer.parentNode;
        	$('#' + tableContainerParent.id).prepend(filtersContainer);
        }   

        var table = document.createElement('table');
        table.id = _tableName + _TABLESUFFIX;

        var tableHeader = document.createElement('thead');
        var tableHeaderRows = _createTableHeaderRows(_headers);

        for (var index = 0; index < tableHeaderRows.length; index++) {
            tableHeader.appendChild(tableHeaderRows[index]);
        }

        table.appendChild(tableHeader);
        table.appendChild(document.createElement('tbody'));
        tableContainer.appendChild(table);

        var paginationControls = document.createElement('div');
        paginationControls.setAttribute('class', _tableName + '-table pagination-controls');
        tableContainer.appendChild(paginationControls);
        
        if (!!tableSectionTitle) {
            // since a table section title was specified we need to add a collapsible section
            var sectionDivider = document.createElement('div');
            sectionDivider.setAttribute('class', 'section-divider');
            sectionDivider.id = table.id + 'SectionHeader';
            
            var chevron = document.createElement('i');
            chevron.setAttribute('class', 'fa fa-chevron-right fa-rotate-90');
            sectionDivider.appendChild(chevron);
            
            var sectionTitle = document.createElement('span');
            sectionTitle.setAttribute('class', 'tab-text');
            sectionTitle.appendChild(document.createTextNode(tableSectionTitle));
            sectionDivider.appendChild(sectionTitle);
            
            if (!!_defaultOptions.includeFilter || !!_defaultOptions.includeExport || !!_defaultOptions.includeRefresh) {
                var sectionToolbar = document.createElement('div');
                sectionToolbar.setAttribute('class', 'section-divider-toolbar');
                
                _addToolbarItems(sectionToolbar, refreshCallback, 'section-divider-toolbar-item');
                sectionDivider.appendChild(sectionToolbar);
            }

            tableContainer.parentNode.insertBefore(sectionDivider, tableContainer);
            $('#' + table.id + 'SectionHeader .fa-chevron-right').on('click', _toggleTableDisplay);
        } else if (!!_defaultOptions.includeFilter || !!_defaultOptions.includeExport || !!_defaultOptions.includeRefresh) {
            // no table section was defined so we just need to add the table toolbar
        	var tableToolbar;
        	
        	if (!!_toolbarContainerId) {
        		tableToolbar = document.getElementById(_toolbarContainerId);
                _addToolbarItems(tableToolbar, refreshCallback, 'table-toolbar-item');
        	} else {
	            tableToolbar = document.createElement('div');
	            tableToolbar.setAttribute('class', 'table-toolbar');
	            _addToolbarItems(tableToolbar, refreshCallback, 'table-toolbar-item');
	            tableContainer.parentNode.insertBefore(tableToolbar, tableContainer);
        	}
        }
        
        if (!!refreshCallback) {
            $('#' + 'refresh' + _tableName[0].toUpperCase() + _tableName.substring(1)).on('click', function(event) {
                if (typeof refreshCallback === 'function') {
                    refreshCallback.call(this, event);
                }
            });
        }
        
        if (!!tableControls) {
            // Add table controls...Add/Edit/Delete buttons
            var buttons = [];
            
            if (!!tableControls.addButton) {
                buttons.push(_createTableControlButton(tableControls.addButton, 'AddButton', (typeof addButtonText !== 'undefined' ? addButtonText : 'Add')));
            }
            
            if (!!tableControls.editButton) {
                buttons.push(_createTableControlButton(tableControls.editButton, 'EditButton', (typeof editButtonText !== 'undefined' ? editButtonText : 'Edit')));
            }
            
            if (!!tableControls.deleteButton) {
                var deleteButton = _createTableControlButton(tableControls.deleteButton, 'DeleteButton', (typeof deleteButtonText !== 'undefined' ? deleteButtonText : 'Delete'));
                buttons.push(deleteButton);
                
                if (!tableControls.deleteButton.callback) {
                    deleteButton.addEventListener('click', _showDeleteConfirmationDialog);

                    if (!!tableControls.deleteButton.deleteConfirmationCallback) {
                        _deleteConfirmationCallback = tableControls.deleteButton.deleteConfirmationCallback;
                    }
                    
                    if (!!tableControls.deleteButton.deleteCancelCallback) {
                        _deleteCancelCallback = tableControls.deleteButton.deleteCancelCallback;
                    }
                }
            }
            
            if (buttons.length > 0) {
                tableControls = document.createElement('div');
                tableControls.setAttribute('class', 'table-controls');
                
                for (var buttonIndex = 0; buttonIndex < buttons.length; buttonIndex++) {
                    tableControls.appendChild(buttons[buttonIndex]);
                }
                
                tableContainer.appendChild(tableControls);
            }
        }
        
        return _initializeDataTable(dataTablesOptions, rowSelectionType);
    };
    
    /**
     * Retrieves the DataTables representation of the table component.
     * 
     * @returns The DataTables representation of the table component.
     */
    this.getTable = function() {
        return _table;
    };
    
    /**
     * Clears the DataTables table.
     */
    this.clear = function() {
        if (!!_table) {
            _table.clear();
        }
    };
    
    /**
     * Displays the delete confirmation dialog
     */
    this.showDeleteConfirmationDialog = function(deleteCallback, cancelCallback, animateOpen, animateClose) {
        _showDeleteConfirmationDialog(deleteCallback, cancelCallback, animateOpen, animateClose);
    };
}

/* example usage

// multi-row headers
var headers = [
    [
        {title : 'one', rowspan : '2'}, 
        {title : 'two', colspan : '3', displayValue : 'Something New', id : 'topColumn', clazz : 'queue-position-column'}, 
        {title : 'six', rowspan : '2'}
    ],
    [
        {title : 'three', clazz : 'queue-position-column'}, 
        {title : 'four', className : 'queue-position-column'}, 
        {title : 'five', clazz : 'queue-position-column'}
    ]
];

// single row headers
var headers = [
    {title : 'one'}, 
    {title : 'two', displayValue : 'Something New', clazz : 'queue-position-column'}, 
    {title : 'three', clazz : 'queue-position-column'}, 
    {title : 'four', className : 'queue-position-column'}, 
    {title : 'five'}
];

// DataTables column definitions
var columns = [
    {
        data : 'one',
        render : function(value, type) {
            if (type === 'display') {
                return '<div class="expand-image" role="button" title="' + value + '"></div><span>' + value + '</span>';
            } else {
                return value;
            }
        },
        defaultContent : ''
    },
    {
        data : 'two',
        defaultContent : ''
    },
    {
        data : 'three',
        defaultContent : ''
    },
    {
        data : 'four',
        defaultContent : ''
    },
    {
        data : 'five',
        defaultContent : ''
    }
];

// DataTables table data
var data = [
    {one : 'a', two : 'b', three : 'c', four : 'd', five : 'e'} 
];

// The refresh button callback is responsible for clearing the table, getting new data, and updating the table.
var refreshHandler = function() {
    var table = abcTable.getTable();
    table.clear();
    table.rows.add(getTableData());
    table.draw();
};

// Table controls
var controls = {
    addButton : {
        clazz : 'add-button',
        callback : function() {
            console.log('add button clicked');
        }
    },
    editButton : {
        clazz : 'edit-button',
        disabled : 'disabled',
        enablement : 'single'
    },
    deleteButton : {
        clazz : 'delete-button',
        disabled : 'disabled',
        enablement : 'multi',
        callback : function() {
            console.log('delete button clicked');
        },
        deleteConfirmationCallback : function() {
            console.log('confirmation dialog delete button clicked');
        },
        deleteCancelCallback : function() {
            console.log('confirmation dialog cancel button clicked');
        }
    }  
};

var dataTablesOptions = {
    columns : columns,
    data : data
};

// create a new SimpleTableComponent object
var tableComponent = new SimpleTableComponent('abc', '#def', headers);

// create the table on the page
tableComponent.createTable(dataTablesOptions, 'single', 'Test Table', refreshHandler, controls);

// a simple example of adding a click handler for expading/collapsing rows
$('#abcTable').on('click', 'td > .expand-image', function() {
    var selectedRow = tableComponent.getTable().row($(this).closest('tr'));
    
    if (!$(this).hasClass('expanded')) {
        selectedRow.child('<div class="row-details">DETAILS</div>', 'details').show();
        $('.row-details', selectedRow.child()).slideDown();
    } else {
        $('.row-details', selectedRow.child()).slideUp(function() {
            selectedRow.child.hide();
        });
    }
    
    $(this).toggleClass('expanded');
});
*/